export default __webpack_public_path__ + "static/media/carpet2.0760833f.jpeg";